module.exports = __webpack_public_path__ + "static/media/combo-on-maroon-palpation-pad.41efbfd0.JPG";